export interface GuestContentImageParams {
    w?: number;
    h?: number;
    maxW?: number;
    dpr?: number;
    fit?: string;
}

/** CDN image resize presets for review guest photos. */
export const GUEST_CONTENT_IMAGE_PRESETS: Record<'thumbnail' | 'preview', GuestContentImageParams> = {
    /** Grid card thumbnail (~220px wide, 4:3). */
    thumbnail: { w: 440, h: 330, fit: 'crop' },
    /** Full-size preview when opening the image. */
    preview: { w: 1600, maxW: 1200, fit: 'crop' },
};

const RESIZABLE_GUEST_CONTENT_URL = /images\.casago(?:stage)?\.com\/review-images\//;

export const isResizableGuestContentUrl = (url: string | null | undefined): url is string =>
    Boolean(url && RESIZABLE_GUEST_CONTENT_URL.test(url));

export const appendGuestContentImageParams = (url: string | null | undefined, params: GuestContentImageParams): string | null => {
    if (!url) {
        return null;
    }

    if (!isResizableGuestContentUrl(url)) {
        return url;
    }

    const searchParams = new URLSearchParams();
    if (params.w != null) {
        searchParams.set('w', String(params.w));
    }
    if (params.h != null) {
        searchParams.set('h', String(params.h));
    }
    if (params.maxW != null) {
        searchParams.set('max-w', String(params.maxW));
    }
    if (params.dpr != null) {
        searchParams.set('dpr', String(params.dpr));
    }
    if (params.fit) {
        searchParams.set('fit', params.fit);
    }

    const query = searchParams.toString();
    if (!query) {
        return url;
    }

    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${query}`;
};

export const buildGuestContentDisplayUrl = (
    url: string | null | undefined,
    preset: keyof typeof GUEST_CONTENT_IMAGE_PRESETS
): string | null => appendGuestContentImageParams(url, GUEST_CONTENT_IMAGE_PRESETS[preset]);
